import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import {CircularProgress} from '@material-ui/core';

const styles = {
  ButtonStandard: {
    'backgroundColor': '#282C40',
    'color': 'white',
    'borderRadius': 4,
    'padding': '10px 30px',
    'display': 'flex',
    'alignItems': 'center',
    'justifyContent': 'center',
    'gap': '20px',
    '&:hover': {
      backgroundColor: '#464d70', // Hover stil
    },
    '&:disabled': {
      backgroundColor: '#5D6278',
      color: 'white',
      opacity: 0.5,
      pointerEvents: 'none',
    },
  },
};

const AppButtonComponent = ({onPress, label, disabled, type, busy}) => {
  const _busy = busy !== undefined ? busy : false;

  return (<Button
    style={styles.ButtonStandard}
    onClick={onPress}
    disabled={disabled}
    type={type}
  >
    {_busy ? <CircularProgress size={24} style={{marginRight: 10}} /> : null}
    {label}
  </Button>);
};

AppButtonComponent.propTypes = {
  label: PropTypes.string.isRequired,
  onPress: PropTypes.func.isRequired,
  disabled: PropTypes.bool, // Dodato da omogući onemogućavanje
  type: PropTypes.string, // Dodato da omogući tip dugmeta
  busy: PropTypes.bool, // Dodato da omogući prikazivanje indikatora
};

AppButtonComponent.defaultProps = {
  disabled: false, // Podrazumevano dugme nije onemogućeno
  type: 'button', // Podrazumevano je tip button
};

export const AppButton = (AppButtonComponent);
